import { createPinia } from 'pinia'

const store = createPinia()

export default store

